import React from 'react';
import { connect } from 'react-redux';
import merge from 'lodash/merge';
import List from '../../../../../../../components/common/List';
import Form from '../../../../../../../components/common/Form.js';
import commify from '../../../../../../../modules/ajio-util/commify.js';
import Icon from '../../../../../../atoms/Icon';
import Divider from '../../../../../../atoms/Divider';
import { getLuxeFlags } from '../../../../../../../Flags/selectors';
import { FLEEK_STORE } from '../../../../../../../constants/constant';

class FacetCheckboxModalContentL3Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredCategoryData: []
    };
  }

  getFormDefaultValues() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  formatChildrens(
    childrens = [],
    formSelectedValues = [],
    entities = {},
    facetCode,
    searchTerm,
    luxe
  ) {
    const {
      oldFlow,
      isFilterImprovementEnabled = false,
      filterImprovementConfig = {},
      parentEntityId = '',
      seletedL1Category = ''
    } = this.props;
    const { suggestedTitle = '', otherTitle = '' } = filterImprovementConfig['category'] || {};
    const parentEntity = entities[parentEntityId] || {};
    const { suggestedValues = [] } = parentEntity;
    const selectedCategorySuggestedValues = (suggestedValues || []).filter(entityId => {
      const entity = entities[`${entityId}`] || {};
      const { name } = entity;
      if (name && seletedL1Category && name.toLowerCase().startsWith(seletedL1Category)) {
        return true;
      }
      return false;
    });
    const { l1l3nestedcategory: prevData } = this.props.currentFacetsQuery || {};
    const newData = prevData?.map(prev => `l1l3nestedcategory-${prev}`);
    const topCat = isFilterImprovementEnabled
      ? selectedCategorySuggestedValues || []
      : this.state.filteredCategoryData;
    const facetSelectedValues = formSelectedValues[facetCode] || [];
    let selectedEntityIds = [];
    selectedEntityIds = childrens.filter(entityId => {
      const entity = entities[entityId];
      const { code } = entity;
      return facetSelectedValues.includes(code);
    });
    const updatedEntities = newData?.filter(data => selectedEntityIds.includes(data)) || [];
    let allItemListTitle = [];
    let topCatItemListTitle = [];
    allItemListTitle.push({ title: isFilterImprovementEnabled ? otherTitle : 'All Categories' });
    topCatItemListTitle.push({
      title: isFilterImprovementEnabled ? suggestedTitle : 'Top Categories'
    });
    const finalTopCategories = filterChildrenByName(
      searchTerm,
      isFilterImprovementEnabled
        ? selectedCategorySuggestedValues || []
        : this.state.filteredCategoryData,
      entities
    );
    const fullEntityIds = childrens;
    const finalTopData = searchTerm ? finalTopCategories : topCat;
    if (finalTopData?.length === 0) {
      topCatItemListTitle = [];
    }
    if (fullEntityIds?.length === 0) {
      allItemListTitle = [];
    }
    if (finalTopData?.length === 0 && fullEntityIds?.length === 0) {
      return [{ title: 'No results found' }];
    }
    if (luxe && !isFilterImprovementEnabled) {
      return [...fullEntityIds];
    } else {
      return [
        ...(oldFlow ? [] : selectedEntityIds),
        ...(oldFlow ? [] : topCatItemListTitle),
        ...(oldFlow ? [] : finalTopData),
        ...allItemListTitle,
        ...fullEntityIds
      ];
    }
  }

  render() {
    const {
      entities = {},
      parentEntityId,
      rightPaneFormValues,
      seletedL1Category,
      setSeletedL1Category,
      disableBackButton,
      currentStore,
      luxeFlags,
      showSearchBar = true,
      applyFilters,
      clearFilterState,
      clearFilters,
      oldFlow,
      popupFilterFromBottom = false,
      shouldHideCategoryTitle = false,
      isFilterImprovementEnabled = false
    } = this.props;
    const categoriesArr = [];
    const { filteredCategoryData } = this.state;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
    const isFleek = currentStore === FLEEK_STORE;
    const parentEntity = entities[parentEntityId] || {};
    let { name = '', childrens = [], code, suggestedValues = [] } = parentEntity;
    childrens = childrens.filter(entityId => {
      const entity = entities[`${entityId}`] || {};
      const { name } = entity;
      if (name && seletedL1Category && name.toLowerCase().startsWith(seletedL1Category)) {
        return true;
      }
      return false;
    });

    const style = {
      fontSize: '1.8rem',
      color: isFleek ? '#FFF' : '#254153',
      fontWeight: 'bold',
      position: 'absolute',
      top: '10px',
      right: '10px',
      opacity: '.7'
    };

    const luxeStyle = {
      fontSize: '24px',
      position: 'absolute',
      top: '6px',
      left: '16px'
    };

    const topCategories = (arr = []) => {
      let topCategoriesArr = arr.sort((a, b) => b.count - a.count);
      if (arr.length > 5) {
        topCategoriesArr = topCategoriesArr.slice(0, 5);
      } else {
        topCategoriesArr = arr.slice(0, arr.length);
      }
      let newTopCat = [];
      for (let i = 0; i <= topCategoriesArr.length - 1; i++) {
        if (topCategoriesArr[i]) {
          const data = topCategoriesArr[i]?.code;
          const finalData = `l1l3nestedcategory-${data}`;
          if (data !== undefined && !this.state.filteredCategoryData?.length) {
            newTopCat.push(finalData);
          }
        }
      }
      if (!this.state.filteredCategoryData?.length) {
        this.setState({
          filteredCategoryData: [...newTopCat]
        });
      }
    };

    return (
      <div>
        <div
          className={luxe ? 'luxe-selected-facet-category-title' : 'selected-facet-category-title'}
          style={isFleek ? { color: '#FFF' } : {}}
          role="button"
          aria-label={`${seletedL1Category} double tap to go back to previous page`}
          tabIndex={0}
        >
          {!disableBackButton ? (
            <div
              className={luxe ? 'luxeBackChevron' : 'backChevron'}
              aria-hidden="true"
              onClick={() => {
                if (rightPaneFormValues && 'searchTerm' in rightPaneFormValues) {
                  delete rightPaneFormValues.searchTerm;
                }
                const nextRightPaneFormValues = { ...rightPaneFormValues };
                setSeletedL1Category();
                if (rightPaneFormValues) {
                  this.props.setRightPaneFormValues('', nextRightPaneFormValues);
                }
              }}
            >
              {luxe ? (
                <Icon icon="luxe-Go-back" styles={{ fontSize: '1.6rem' }} ariaLabel="back" />
              ) : (
                <Icon
                  icon="icon-Chevron-Left"
                  styles={{
                    fontSize: '1rem',
                    color: isFleek ? '#EBFF00' : '#202020',
                    fontWeight: 'bold'
                  }}
                  ariaLabel="back"
                />
              )}
            </div>
          ) : null}
          {!shouldHideCategoryTitle && (
            <span aria-hidden="true" className={luxe ? 'luxe-category-title' : 'category-title'}>
              {seletedL1Category}
            </span>
          )}
        </div>
        {showSearchBar && luxe && (
          <div className="luxe-facet-category-divider">
            <Divider />
          </div>
        )}
        <Form
          defaultValues={this.getFormDefaultValues()}
          getFormValues={() => {
            const defaultValues = this.getFormDefaultValues();
            return rightPaneFormValues || defaultValues;
          }}
          setFormValues={formValues => {
            this.props.setRightPaneFormValues(code, formValues);
          }}
          onSubmit={() => {}}
        >
          {({ getFormDefaultProps, getFormValue }) => {
            let formValue = getFormValue(code);
            let searchTerm = getFormValue('searchTerm');
            let filteredChildrens = filterChildrenByName(searchTerm, childrens, entities);
            filteredChildrens = this.formatChildrens(
              filteredChildrens,
              this.getFormDefaultValues(),
              entities,
              code,
              searchTerm,
              luxe
            );

            let listDistribution = [];
            filteredChildrens.forEach(item => {
              if (typeof item === 'object' && item.title) {
                listDistribution.push([item]);
              } else {
                const lastGroup = listDistribution[listDistribution.length - 1];
                if (lastGroup) {
                  lastGroup.push(item);
                } else {
                  listDistribution.push([item]);
                }
              }
            });

            return (
              <div>
                {showSearchBar && (
                  <div
                    className={`${
                      luxe ? 'luxe-search-term-container' : 'search-term-container'
                    } facet-category-selected`}
                    style={isFleek ? { background: '#1B1F23' } : {}}
                  >
                    <input
                      {...getFormDefaultProps({
                        type: 'text',
                        name: 'searchTerm'
                      })}
                      value={Array.isArray(searchTerm) ? '' : searchTerm}
                      className={luxe ? 'luxe-search-term' : 'search-term'}
                      id="search-term"
                      placeholder="Search for categories"
                      autoComplete="off"
                      style={isFleek ? { background: '#1B1F23', color: '#FFF' } : {}}
                    />
                    {luxe ? (
                      <Icon icon="luxe-Search" styles={luxeStyle} ariaLabel="search" />
                    ) : (
                      <Icon icon="icon-Search" styles={style} ariaLabel="search" />
                    )}
                  </div>
                )}
                <div className={`${popupFilterFromBottom ? 'category_bottom' : ''}`}>
                  {listDistribution.map((eItem, iKey) => {
                    const isCategoryList = code === 'l1l3nestedcategory';
                    const noMarginClass =
                      isCategoryList && iKey + 1 !== listDistribution.length
                        ? 'rilrtl-list-no-margin'
                        : '';
                    return (
                      <div role={isCategoryList ? 'list' : undefined}>
                        <List
                          ignoreListBehavior={code === 'brand' || isCategoryList}
                          numOfItems={eItem.length}
                          avoidFirstLITag={true}
                          className={noMarginClass}
                          listItemRenderer={listProps => {
                            const { index } = listProps;
                            const entityId = eItem[index];
                            if (typeof entityId === 'object') {
                              return (
                                <div
                                  style={
                                    isFleek && entityId.title === 'No results found'
                                      ? { margin: 'auto', width: '50%' }
                                      : {}
                                  }
                                >
                                  <div
                                    className={
                                      entityId.title === 'No results found'
                                        ? `facet-no-result-found ${
                                            isFleek ? 'fleek-facet-no-result-found' : ''
                                          }`
                                        : 'facet-linkname facet-directory-title'
                                    }
                                    style={
                                      isFleek && entityId.title === 'No results found'
                                        ? {
                                            color: '#FFF',
                                            position: 'absolute',
                                            top: '50%',
                                            fontSize: '12px',
                                            textTransform: 'initial',
                                            marginTop: '10px'
                                          }
                                        : isFleek
                                        ? { color: '#FFF' }
                                        : {}
                                    }
                                    role="heading"
                                    aria-level={2}
                                  >
                                    <strong>{entityId.title}</strong>
                                  </div>
                                </div>
                              );
                            }
                            const entity = entities[`${entityId}`] || {};
                            const ent = categoriesArr.filter(id => id.code === entity.code);
                            if (!ent.length) {
                              categoriesArr.push(entity);
                            }
                            filteredChildrens?.length - 1 === index
                              ? topCategories(categoriesArr)
                              : null;
                            let entityName = entity.name || '';
                            entityName =
                              entityName.substring(entityName.indexOf('-') + 1).trim() || '';
                            entityName = entityName.trim();
                            let isChecked = false;
                            if (formValue) {
                              isChecked = formValue.includes(entity.code);
                            }
                            return (
                              <div role={isCategoryList ? 'listitem' : undefined}>
                                <label className="facet-linkname" htmlFor={entity.name}>
                                  <span
                                    className={
                                      luxe
                                        ? 'rilrtl-list-item__end-detail ----'
                                        : 'rilrtl-list-item__newend-detail ----'
                                    }
                                    role="checkbox"
                                    checked={isChecked}
                                    aria-checked={isChecked}
                                    aria-labelledby={`facet-list-title-name-${(entity.name || '')
                                      .trim()
                                      .replace(/\s+/g, '')} facet-list-title-count-${commify(
                                      entity.count || ''
                                    )}`}
                                  >
                                    <input
                                      tabIndex={-1}
                                      {...getFormDefaultProps({
                                        type: 'checkbox',
                                        name: code,
                                        value: entity.code
                                      })}
                                      id={entity.name}
                                      checked={isChecked}
                                    />
                                    {luxe ? (
                                      <Icon
                                        ariaHidden={true}
                                        icon={`${
                                          isChecked ? 'luxe-Checkbox-Selected' : 'luxe-Checkbox'
                                        }`}
                                        styles={
                                          isChecked
                                            ? { fontSize: '2.2rem', color: '#121212' }
                                            : { fontSize: '2.2rem', opacity: 0.5 }
                                        }
                                      />
                                    ) : (
                                      <Icon
                                        ariaHidden={true}
                                        icon={`${
                                          isChecked ? 'icon-Checkbox-Selected' : 'icon-Check-box'
                                        }`}
                                        styles={
                                          isFleek
                                            ? { fontSize: '2.2rem', color: '#EBFF00' }
                                            : { fontSize: '2.2rem' }
                                        }
                                      />
                                    )}
                                  </span>
                                  {luxe || oldFlow ? (
                                    <span
                                      aria-hidden="true"
                                      className={`rilrtl-list-luxe-item__title ${
                                        isChecked ? 'list-active' : ''
                                      }`}
                                    >
                                      <span
                                        id={`facet-list-title-name-${(entity.name || '')
                                          .trim()
                                          .replace(/\s+/g, '')}`}
                                        className="facet-list-title-name facet-list-title-name_luxe_alignment"
                                        style={isFleek ? { color: '#FFF' } : {}}
                                        aria-label={entityName
                                          .replace(/Rs\.?/g, 'Rupees')
                                          .replace(/(\d+)\s*-\s*(\d+)/, '$1 to $2')}
                                      >
                                        {`${entityName}`}{' '}
                                      </span>
                                      <span
                                        id={`facet-list-title-count-${commify(entity.count || '')}`}
                                        className={`facet-list-title-count ${
                                          isFleek ? 'fleek-color-important' : ''
                                        }`}
                                        aria-label={`(${commify(entity.count || '')}) ${
                                          entity.count ? 'items' : ''
                                        } `}
                                      >
                                        {`(${commify(entity.count || '')})`}
                                      </span>
                                    </span>
                                  ) : (
                                    <span
                                      aria-hidden
                                      className={`rilrtl-list-item__title ${
                                        isChecked ? 'list-active' : ''
                                      }`}
                                    >
                                      <span
                                        id={`facet-list-title-name-${(entity.name || '')
                                          .trim()
                                          .replace(/\s+/g, '')}`}
                                        className={`facet-list-title-name facet-list-title-name_alignment ${
                                          isFleek ? 'fleek-color-important' : ''
                                        }`}
                                        style={isFleek ? { marginLeft: '10px' } : {}}
                                        aria-label={`${(entityName.length > 30
                                          ? `${entityName.slice(0, 30)}...`
                                          : entityName
                                        )
                                          .replace(/Rs\.?/g, 'Rupees')
                                          .replace(/(\d+)\s*-\s*(\d+)/, '$1 to $2')} (${commify(
                                          entity.count || ''
                                        )})`}
                                      >
                                        {`${
                                          entityName.length > 30
                                            ? `${entityName.slice(0, 30)}...`
                                            : entityName
                                        }`}{' '}
                                        {`(${commify(entity.count || '')})`}
                                      </span>
                                    </span>
                                  )}
                                </label>
                              </div>
                            );
                          }}
                          isFleek={isFleek}
                          oldFlow={oldFlow}
                          keepDefaultRole={true}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="rilrtl-toolbar-bottom-fixed-adjust rilrtl-toolbar-bottom-fixed-adjust--filter-by" />
              </div>
            );
          }}
        </Form>
      </div>
    );
  }
}

function filterChildrenByName(searchString = '', childrens = '', entities) {
  if (!searchString) return childrens;
  if (!Array.isArray(searchString)) {
    searchString = searchString.toLowerCase();
  }
  return childrens.filter(entityId => {
    const entity = entities[entityId] || {};
    let { name = '' } = entity;
    name = name.split('-')[1] || '';
    name = name.trim().toLowerCase();
    if (Array.isArray(searchString)) {
      return searchString.includes(name.charAt(0));
    }
    return name.includes(searchString);
  });
}

function mapStateToProps(state) {
  const { flags, metaData, facets = {} } = state;
  const { name } = metaData;
  const { nextFacets = {}, currentFacets = {} } = facets || {};
  const { entities = {} } = nextFacets;
  const { query: currentFacetsQuery } = currentFacets;
  const { query: facetsQuery } = nextFacets;
  return {
    entities,
    facetsQuery,
    currentStore: name,
    luxeFlags: getLuxeFlags(flags),
    currentFacetsQuery
  };
}

export default connect(mapStateToProps)(FacetCheckboxModalContentL3Category);
